<template>
  <div class="app-book-tariff-options">
    <OptionsView :options.sync="bookedOptions"
                 :option-bookable="Object.keys(tariffoptions).length > 0"
                 :option-deactivatable="true"
                 :step-book="'selectBook'"
                 :balance="currentCustomer.balance"
                 :step-deactivate="'selectDeactivate'"
                 @update-step="updateStep"
                 :step-book-label="lblBookTariffOptions"
                 :step-deactivate-label="lblDeactivateTariffOptions"
                 v-if="showView">
      <template v-for="slot in possibleChildSlotsFor('View')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </OptionsView>
    <ConsumptionView v-if="showView" :extra-tariff-options="extraTariffOptions">
      <template v-for="slot in possibleChildSlotsFor('Consumption')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ConsumptionView>
    <OptionsSelect
      :options="availableOptions"
      :mutableSelectedOptions.sync="selected"
      @select-option="selectOption"
      @update-step="updateStep"
      :next-step="'summary'"
      :previous-step="'view'"
      :balance="true"
      @update-options="updateOptions"
      @is-disabled="isDisabled"
      :loading="loading"
      v-if="showSelect">
      <template v-for="slot in possibleChildSlotsFor('Select')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </OptionsSelect>
    <SelectDeactivate
      :options="bookedOptions"
      :balance="null"
      :next-step="'summary'"
      :previous-step="'view'"
      :view-deactivate="viewDeactivate"
      @update-step="updateStep"
      @update-options="saveDeactivate"
      v-if="showSelectForDeactivate"
      :loading="loading"
    >
      <template v-for="slot in possibleChildSlotsFor('SelectDeactivate')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </SelectDeactivate>
    <Summary v-if="showSummary"
             :options="selected"
             :next-step="'success'"
             :is-automatic-extension="isAutomaticExtension"
             :previous-step="'selectBook'"
             @update-step="updateStep"
             @cancel-option="confirmDeactivate"
             @save-options="saveOptions"
             :loading="loading"
             :is-deactivate="isDeactivate"
    >
      <template v-for="slot in possibleChildSlotsFor('Summary')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Summary>
    <Success
      v-if="showSuccess && viewDeactivate === true"
      :error-options="getErrorOptions"
      :success-options="getSuccessfulOptions"
      :options="allOptions"
      @update-step="updateStep"
      :previous-step="'view'"
      :is-deactivate="true"
    >
      <template v-for="slot in possibleChildSlotsFor('SuccessDeactivate')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Success>
   <Success
      v-if="showSuccess && viewDeactivate === false"
      :error-options="getErrorOptions"
      :success-options="getSuccessfulOptions"
      :options="allOptions"
      @update-step="updateStep"
      :previous-step="'view'"
      :is-deactivate="false"
    >
     <template  v-for="slot in possibleChildSlotsFor('Success')" v-slot:[`${slot.child}`]>
       <slot :name="`${slot.parent}`"></slot>
     </template>
    </Success>
  </div>
</template>

<script>
import Summary, { stepName as summaryStepName } from '../generic/Summary.vue'
import OptionsSelect, { stepName as selectStepName } from '../generic/Select.vue'
import SelectDeactivate, { stepName as selectDeactivateStepName } from '../generic/SelectDeactivate.vue'
import OptionsView, { stepName as viewStepName } from '../generic/View.vue'
import Success, { stepName as successStepName } from '../generic/ServiceOptions/Success.vue'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import ConsumptionView from './ConsumptionView.vue'
import transaction from '@/mixins/transaction'
import slotProxy from '@/mixins/slotProxy'

export default {
  name: 'BookTariffOptionsWrapper',
  components: { ConsumptionView, OptionsView, Success, OptionsSelect, SelectDeactivate, Summary },
  data () {
    return {
      viewDeactivate: false,
      selected: [],
      isDeactivate: false,
      tariffoptions: {
        bookedTariffoptions: {
          bookedTariffoptions: []
        },
        bookableTariffoptions: {
          bookableTariffoptions: []
        }
      },
      currentCustomer: {
        balance: null
      },
      loading: false,
      isAutomaticExtension: false
    }
  },
  mixins: [
    transaction('bookTariffOptions'),
    slotProxy()
  ],
  props: {
    lblBookTariffOptions: {
      type: String,
      default: 'Tarifoptionen buchen'
    },
    lblDeactivateTariffOptions: {
      type: String,
      default: 'Tarifoptionen deaktivieren'
    },
    extraTariffOptions: {
      type: Object,
      default: () => {}
    },
    extraStatus: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    ...mapMutations('bookTariffOptions', [
      'changeStep',
      'saveTariffOptions'
    ]),
    ...mapActions('bookTariffOptions', [
      'confirmTariffoption',
      'deactivateTariffOption',
      'initialbookTariffoption',
      'initiateCancelTariffOption',
      'cancelTariffOptionConfirm'
    ]),
    async saveOptions (nextStep) {
      this.loading = true
      await this.confirmTariffoption({ nextStep: nextStep, process: 'bookTariffOptions' })
      this.$apollo.queries.tariffoptions.refresh()
      this.loading = false
    },
    updateStep (step) {
      if (step === 'selectDeactivate') {
        this.viewDeactivate = true
      } else {
        this.viewDeactivate = false
      }
      if (step === 'view') {
        this.viewDeactivate = false
      }
      if (!this.showSelect || step !== summaryStepName) {
        this.changeStep(step)
      }
    },
    async confirmDeactivate (step) {
      this.loading = true
      await this.cancelTariffOptionConfirm().then((success) => {
        if (success) {
          this.loading = false
          this.changeStep(step)
        }
      })
    },
    async updateOptions (options) {
      this.loading = true
      await this.saveTariffOptions(options)
      this.isDeactivate = false
      this.isAutomaticExtension = options.some(item => item.automaticExtension === true)
      await this.initialbookTariffoption({ process: 'bookTariffOptions', nextStep: 'summary' })
      this.loading = false
    },
    async saveDeactivate ({ step, options }) {
      this.isDeactivate = true
      this.loading = true
      this.selected = [options]
      this.isAutomaticExtension = options.automaticExtension
      await this.initiateCancelTariffOption({ tariffoptionId: options.id }).then((success) => {
        if (success) {
          this.$apollo.queries.tariffoptions.refresh()
          this.viewDeactivate = true
          this.changeStep(step)
        }
      })
      this.loading = false
    },
    selectOption (tariffOption) {
      const me = this
      tariffOption.notBookableWith.forEach(option => {
        const index = me.selectedTariffOptions.findIndex(tariffOption => {
          return tariffOption.tariffOptionId === option
        })
        if (index > -1) {
          me.selectedTariffOptions.splice(index, 1)
        }
      })
    },
    isDisabled (tariffOption) {
      return this.disabledTariffOptions.find(function (checkOption) {
        return checkOption.tariffOptionId === tariffOption.tariffOptionId
      }) !== undefined
    }
  },
  computed: {
    ...mapGetters('bookTariffOptions', [
      'getStep',
      'getDataResponseOptions',
      'getSuccessfulOptions',
      'getErrorOptions'
    ]),
    isDeactivate_: function () {
      return this.isDeactivate
    },
    selectedTariffOptions: {
      get: function () {
        if (this.selected !== null) {
          return this.selected
        }
        return []
      },
      set: function (value) {
        if (this.selected) {
          this.selected = value
        }
      }
    },
    disabledTariffOptions: function () {
      const disabledOptions = []
      if (this.selectedTariffOptions !== undefined) {
        this.selectedTariffOptions.forEach(function (tariffOption) {
          if (tariffOption.notBookableWith) {
            tariffOption.notBookableWith.forEach(function (disableOption) {
              disabledOptions.push(disabledOptions)
            })
          }
        })
      }
      return disabledOptions
    },
    showSummary () {
      return this.getStep === summaryStepName
    },
    showSelect () {
      return this.getStep === selectStepName
    },
    showView () {
      return this.getStep === viewStepName
    },
    showSuccess () {
      return this.getStep === successStepName
    },
    showSelectForDeactivate () {
      return this.getStep === selectDeactivateStepName
    },
    allOptions: function () {
      return [
        ...this.bookedOptions,
        ...this.availableOptions
      ]
    },
    bookedOptions: function () {
      const me = this
      return (this.tariffoptions?.bookedTariffoptions?.bookedTariffoptions || []).map(tariffOption => {
        return Object.assign(
          {},
          tariffOption,
          {
            id: tariffOption.tariffoptionId,
            status: (me.extraStatus ? me.extraStatus[tariffOption.statusKey] || '' : ''),
            endOfRuntime: tariffOption.endOfRuntime
          },
          (me.extraTariffOptions ? me.extraTariffOptions[tariffOption.tariffoptionId] || '' : '')
        )
      })
    },
    availableOptions: function () {
      const me = this
      return (this.tariffoptions?.bookableTariffoptions?.bookableTariffoptions || [])
        .filter(tariffOption => {
          return me.extraTariffOptions[tariffOption.tariffoptionId] !== undefined
        })
        .map(tariffOption => {
          return Object.assign(
            {},
            tariffOption,
            {
              id: tariffOption.tariffoptionId
            },
            (me.extraTariffOptions ? me.extraTariffOptions[tariffOption.tariffoptionId] || '' : '')
          )
        })
    }
  },
  apollo: {
    tariffoptions: function () {
      return wrapQuery(
        gql`query bookTariffOptions {
 tariffoptions {
  bookableTariffoptions {
    bookableTariffoptions {
      tariffoptionId
      automaticExtension
      name
      price
      duration {
        amount
        unit
      }
      notBookableWith
      requiresContractSummary
    }
  }
  bookedTariffoptions {
    bookedTariffoptions {
      tariffoptionId
      name
      price
      automaticExtension
      duration {
        amount
        unit
      }
      statusKey
      startOfRuntime
      possibleChangingDate
      endOfRuntime
      cancelable
    }
  }
 }
        }`, this, 'tariffoptions'
      )
    },
    currentCustomer: function () {
      return wrapQuery(
        gql`query bookTariffOptions {
        currentCustomer {
          balance
        }
      }`, this, 'currentCustomer')
    }
  }
}
</script>
